export interface FuturePEMultipleStrategy {
  get revenueGrowthRatePercentage(): number;
  get profitMarginPercentage(): number;
  get futurePE(): number;
  get discountRatePercentage(): number;
  get timeFrame(): number;
  get exchangeRate(): number;
  get futureSharesOutstanding(): number;
  get futureEarnings(): number;
  get futureMarketCapitalisation(): number;
  get sharesOutstandingGrowthRate(): number;
  get sharePriceFutureYear(): number;
  setFairValue(fairValue: number): this;
  setDiscountRate(discountRatePercentage: number): this;
  setFuturePE(futurePE: number): this;
  setProfitMargin(profitMarginPercentage: number): this;
  setRevenueGrowthRate(revenueGrowthRatePercentage: number): this;
  setTimeFrame(timeFrame: number): this;
  calculateFairValue(): number;
  calculateFairValueToListingCurrency(): number;
}

export type CalculationInputs = {
  discountRatePercentage: number;
  futurePE: number;
  profitMarginPercentage: number;
  revenueGrowthRatePercentage: number;
  timeFrame: number;
};
export class FuturePEMultipleContext {
  private strategy: FuturePEMultipleStrategy;

  constructor(strategy: FuturePEMultipleStrategy) {
    this.strategy = strategy;
  }

  get discountRatePercentage(): number {
    return this.strategy.discountRatePercentage;
  }

  get futurePE(): number {
    return this.strategy.futurePE;
  }

  get profitMarginPercentage(): number {
    return this.strategy.profitMarginPercentage;
  }

  get revenueGrowthRatePercentage(): number {
    return this.strategy.revenueGrowthRatePercentage;
  }

  get timeFrame(): number {
    return this.strategy.timeFrame;
  }

  get exchangeRate(): number {
    return this.strategy.exchangeRate;
  }

  get futureSharesOutstanding(): number {
    return this.strategy.futureSharesOutstanding;
  }

  get sharesOutstandingGrowthRate(): number {
    return this.strategy.sharesOutstandingGrowthRate;
  }

  setStrategy(strategy: FuturePEMultipleStrategy) {
    this.strategy = strategy;

    return this;
  }

  setFairValue(fairValue: number) {
    this.strategy.setFairValue(fairValue);

    return this;
  }

  setCalculationInputs({
    discountRatePercentage,
    futurePE,
    profitMarginPercentage,
    revenueGrowthRatePercentage,
    timeFrame,
  }: CalculationInputs) {
    this.strategy
      .setDiscountRate(discountRatePercentage)
      .setFuturePE(futurePE)
      .setProfitMargin(profitMarginPercentage)
      .setRevenueGrowthRate(revenueGrowthRatePercentage)
      .setTimeFrame(timeFrame);

    return this;
  }

  calculateFairValueToListingCurrency(): number {
    return this.strategy.calculateFairValueToListingCurrency();
  }

  calculateFairValueToReportingCurrency(): number {
    return this.strategy.calculateFairValue();
  }

  calculateBreakDown(): {
    futureSharesOutstanding: number;
    futureEarnings: number;
    futureMarketCapitalisation: number;
    sharePriceFutureYear: number;
    exchangeRate: number;
    fairValueReportedPrice: number;
    fairValueListedPrice: number;
    timeFrame: number;
  } {
    return {
      futureSharesOutstanding: this.strategy.futureSharesOutstanding,
      futureEarnings: this.strategy.futureEarnings,
      futureMarketCapitalisation: this.strategy.futureMarketCapitalisation,
      sharePriceFutureYear: this.strategy.sharePriceFutureYear,
      exchangeRate: this.strategy.exchangeRate,
      fairValueReportedPrice: this.strategy.calculateFairValue(),
      fairValueListedPrice: this.strategy.calculateFairValueToListingCurrency(),
      timeFrame: this.strategy.timeFrame,
    };
  }
}
